export default class CnerIgnoreGitConfig{
  static developer_geek = 'prod';
}

